import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import styles from './Slots.module.css';

// --- Используем предоставленные URL картинок ---
/*
const imageUrls = [
  'https://www.pngmart.com/image/tag/gift-icon', // Фрукт 1
  'https://www.pngmart.com/image/tag/gift-icon', // Фрукт 2
  'https://www.pngmart.com/image/tag/gift-icon', // Фрукт 3
];
*/

// Используем локальные картинки из assets
const imageUrls = [
  '/src/assets/gift.svg', // Gift icon 1
  '/src/assets/gift.svg', // Gift icon 2
  '/src/assets/gift.svg', // Gift icon 3
];

// Дублируем массив для бесшовной прокрутки.
// Пусть будет 10 повторений этих трех картинок, чтобы получить 30 элементов,
// как было с числами от 0 до 9.
const slotItems = Array(10).fill(imageUrls).flat();

export const ITEM_HEIGHT = 43.33; // Высота одного элемента

interface SlotProps {
  controls: ReturnType<typeof useAnimation>;
  id: number;
}

const Slot: React.FC<SlotProps> = ({ controls }) => {
  return (
    <div className={styles.slot}>
      <motion.div className={styles.slotReel} animate={controls}>
        {slotItems.map((imageUrl, index) => (
          <div key={index} className={styles.item} style={{ height: ITEM_HEIGHT }}>
            <img src={imageUrl} alt={`slot item ${index}`} />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Slot;
